import { isNullOrEmpty } from '@synqo/frontend-component-library';

// @ai-generated 2026-09-14T00:00:00+00:00 by matthias.gessinger@synqony.com using Claude Opus 5

/**
 * Compares two city names case-insensitively, so the user's own capitalisation is never a
 * contradiction. Accents are kept apart — they tell genuinely different places from one another.
 */
export function isSameCity(left: string | undefined, right: string | undefined): boolean {
    if (isNullOrEmpty(left) || isNullOrEmpty(right)) {
        return false;
    }
    return left.localeCompare(right, undefined, { sensitivity: 'accent' }) === 0;
}

export function matchesLocality(localities: string[], city: string): boolean {
    return localities.some((locality) => isSameCity(locality, city));
}

/**
 * The one locality a postal code leaves no choice about. Several localities are a question only the
 * user can answer, so a single one is the only answer the automation may act on by itself.
 */
export function onlyLocality(localities: string[]): string | undefined {
    return localities.length === 1 ? localities[0] : undefined;
}

/** Shared so that a field with nothing to offer keeps handing down the same empty list. */
const NO_CHOICE: string[] = [];

/**
 * The localities worth putting in the city field's suggestion list. A single locality is no choice:
 * it is either filled in by itself or offered below the field as one click, and a list of one is
 * only a dropdown in the way of both.
 */
export function offerableLocalities(localities: string[]): string[] {
    return localities.length > 1 ? localities : NO_CHOICE;
}
